import React from 'react';

import Button from 'react-bootstrap/Button';

import { useDispatch } from 'react-redux';

import { checkDomain } from '../store/domains';


export default function Domain(props) {
  const dispatch = useDispatch();

  return (
    <tr>
    <td>{props.domain.domain}</td><td>{props.domain.status}</td>
    <td className="text-center"><Button onClick={() => dispatch(checkDomain(props.domain))} variant="primary">Check</Button></td>
    </tr>
  );
}
